import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "base-form header" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", null, "Автомобили контрагентов", -1)
const _hoisted_3 = { class: "base-form" }
const _hoisted_4 = { class: "base-form" }
const _hoisted_5 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_counterparty_filter_component = _resolveComponent("counterparty-filter-component")!
  const _component_el_text = _resolveComponent("el-text")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _hoisted_2,
              _createVNode(_component_el_button, {
                type: "primary",
                icon: _ctx.circleIcon,
                size: "large",
                onClick: _ctx.onAddVehicleClick
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Новый автомобиль ")
                ]),
                _: 1
              }, 8, ["icon", "onClick"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 6 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_el_input, {
                modelValue: _ctx.tableFilterSearchQuery,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tableFilterSearchQuery) = $event)),
                placeholder: "Поиск автомобилей по VIN, гос. номеру, марке и модели, контрагенту",
                onKeyup: _withKeys(_ctx.fetchVehiclesAsync, ["enter"]),
                class: "input-with-select"
              }, {
                append: _withCtx(() => [
                  _createVNode(_component_el_button, { icon: _ctx.searchIcon }, null, 8, ["icon"])
                ]),
                _: 1
              }, 8, ["modelValue", "onKeyup"])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 6 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_counterparty_filter_component, { onSelected: _ctx.onCounterpartyFilterChanged }, null, 8, ["onSelected"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 24 }, {
          default: _withCtx(() => [
            _withDirectives((_openBlock(), _createBlock(_component_el_table, {
              data: _ctx.tableData,
              sortable: "custom",
              "default-sort": { prop: _ctx.tableSortColumn, order: _ctx.tableSortOrder },
              onSortChange: _ctx.onTableSortingChange,
              onRowDblclick: _ctx.onTableRowDblClick
            }, {
              empty: _withCtx(() => [
                _createVNode(_component_el_text, { type: "info" }, {
                  default: _withCtx(() => [
                    _createTextVNode("Список автомобилей пуст ☹️")
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                (_ctx.isPickerMode)
                  ? (_openBlock(), _createBlock(_component_el_table_column, {
                      key: 0,
                      width: "100"
                    }, {
                      default: _withCtx((scope) => [
                        _createVNode(_component_el_button, {
                          size: "small",
                          type: "primary",
                          onClick: (e) => _ctx.onTablePickVehicleClick(scope.row, e)
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Выбрать ")
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_table_column, {
                  label: "Автомобиль",
                  sortable: "",
                  prop: "model"
                }, {
                  default: _withCtx((scope) => [
                    _createVNode(_component_el_link, {
                      underline: false,
                      type: "primary",
                      onClick: (e) => _ctx.onTableVehicleClick(scope.row, e)
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(scope.row.model.manufacturer.name) + " " + _toDisplayString(scope.row.model.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "Контрагент",
                  prop: "model.manufacturer.name"
                }, {
                  default: _withCtx((scope) => [
                    _createTextVNode(_toDisplayString(scope.row.counterparty.lastname) + " " + _toDisplayString(scope.row.counterparty.firstname) + " ", 1),
                    (scope.row.counterparty?.legalEntity?.name)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                          _createVNode(_component_el_text, {
                            type: "info",
                            size: "small"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(scope.row.counterparty.legalEntity.name), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "vin",
                  label: "VIN"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "govermentalNumber",
                  label: "Гос. номер"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "productionDate",
                  label: "Год выпуска"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "mileage",
                  label: "Пробег"
                }),
                (!_ctx.isPickerMode)
                  ? (_openBlock(), _createBlock(_component_el_table_column, {
                      key: 1,
                      align: "right",
                      width: "120"
                    }, {
                      default: _withCtx((scope) => [
                        _createVNode(_component_el_button, {
                          size: "small",
                          type: "danger",
                          onClick: (e) => _ctx.onTableDeleteVehicleClick(scope.row, e)
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Удалить ")
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["data", "default-sort", "onSortChange", "onRowDblclick"])), [
              [_directive_loading, _ctx.tableLoading]
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}